// extracted by mini-css-extract-plugin
export default {"wrapper":"Work_wrapper__qV6Ne","normal":"Work_normal__O0GMz","hover":"Work_hover__XXMjZ"};